import { useMemo } from "react";
import { CreditCard, MapPin, Phone } from "lucide-react";
import { useFormikContext } from "formik";
import { ICheckout, Step } from "@/pages/checkout/hooks/useCheckoutSteps";
import DataCell from "@/components/DataCell";
import { paymentMethodsLabels } from "@/constants/paymentMethods";
import SummaryPanel from '@/pages/checkout/components/ConfirmationView/components/SummaryPanel';
import intersection from 'lodash/intersection';
import { formatPhone } from "@/utils/phones";
import { PaymentMethods } from "@/types/organizations";

interface StepSummaryProps {
    step: Step;
}

const StepSummary = ({ step }: StepSummaryProps) => {
    const formik = useFormikContext<ICheckout>();

    const paymnetMethod = useMemo(() => {
        if (!formik.values.paymentMethod) return '';
        return paymentMethodsLabels[formik.values.paymentMethod as PaymentMethods] ?? '';
    }, [formik.values.paymentMethod])

    const hasErrors = () => {
        const intfieldsWithErrors = intersection(Object.keys(formik.errors), Object.keys(step?.initialValues ?? {}));
        return !!intfieldsWithErrors.length;
    }

    switch(step.id) {
        case 'contact':
            return (
                <SummaryPanel
                    title="¿Quién recibirá el pedido?"
                    icon={<Phone/>}
                    stepId={step.id}
                    error={hasErrors() ? "Información imcompleta" : undefined}
                >
                    <DataCell label="Nombre" value={`${formik.values.name} ${formik.values.lastname}`}/>
                    <DataCell label="Teléfono" value={formatPhone(formik.values.phone, 505)}/>
                    <DataCell label="Email" value={formik.values.email}/>
                </SummaryPanel>
            );
        case 'location':
            return (
                <SummaryPanel
                    title="¿Dónde deseas recibir tu pedido?"
                    icon={<MapPin />}
                    stepId={step.id}
                    error={hasErrors() ? "Información imcompleta" : undefined}
                >
                    <DataCell label="Barrio" value={formik.values.neighborhood}/>
                    <DataCell label="No. casa" value={formik.values.house}/>
                    <DataCell label="Dirección" value={formik.values.address}/>
                </SummaryPanel>
            );
        case 'payment':
            return (
                <SummaryPanel
                    title="¿Cómo deseas pagar?"
                    icon={<CreditCard />}
                    stepId={step.id}
                    error={hasErrors() ? "Información imcompleta" : undefined}
                >
                    <DataCell label="Método de pago" value={paymnetMethod}/>
                </SummaryPanel>
            );
    }
}

export default StepSummary;
